import { render, staticRenderFns } from "./IvvScroller.vue?vue&type=template&id=31a2baa4&"
import script from "./IvvScroller.vue?vue&type=script&lang=ts&"
export * from "./IvvScroller.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports